import React from 'react';
import { SelectableCardProps } from './types';
import './SelectableCard.css';
import { getVersionUrl } from 'common/cacheOverwrite';

export const SelectableCard: React.FC<SelectableCardProps> = ({ title, selected, onClick, description, highlight }) => {
  return (
    <div className={`selectable-card ${selected ? 'selected' : ''}`} onClick={onClick}>
      <div className={`selectable-card__content`}>
        <div className={`selectable-card__title_group`}>
          <div className={`selectable-card__title_label ${highlight ? 'selectable-card__content-highlight' : ''}`}>{title}</div>
          <Radio selected={selected}/>
        </div>
        <div className={`selectable-card__description ${highlight ? 'selectable-card__content-highlight' : ''}`}>{description}</div>
      </div>
    </div>
  );
}

const Radio: React.FC<{selected: boolean}> = ({selected}) => {
  return (
    <div className={'radio'}>
      <img alt={"Radio Button"}
           src={getVersionUrl(selected ? "/assets/images/ico/ic_radio_selected_24.png" : "/assets/images/ico/ic_radio_unselected_24.png")}></img>
    </div>
  );
};